export default __webpack_public_path__ + "static/media/bootstrap-icons.e0bb8268.svg";